import { NgModule } from '@angular/core';
import { LibSharedCommonModule } from '@solvace/common';
import { SvcQuillTextEditorModule } from '@solvace/component/svc-controls/svc-quill-text-editor';
import { SvcQuillEditorMentionDirective } from './svc-quill-editor-mention.directive';

@NgModule({
  declarations: [
    SvcQuillEditorMentionDirective,
  ],
  imports: [
    LibSharedCommonModule,
    SvcQuillTextEditorModule,
  ],
  exports: [
    SvcQuillEditorMentionDirective,
  ],
})
export class SvcQuillEditorMentionModule { }
